import { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
const CustomHandler = ({
  maps,
  setValues,
  overlay,
  overlayInstance,
  updateOverlay,
  handlerInstance,
}) => {
  const ref = useRef({
    initialLatLng: null,
    initialMakerker: null,
    rotation: 0,
    lastRotation: 0,
    markerPosition: null,
    radiusX: overlay.radiusX,
    radiusY: overlay.radiusY,
  });

  const markerSetInitialPosition = e => {
    ref.current.initialMarker = {
      lat: e.latLng.lat,
      lng: e.latLng.lng,
    };
  };

  const markerDragNewPoints = (e, index) => {
    const center = overlayInstance.getCenter();
    const distance = Math.ceil(
      maps.geometry.spherical.computeDistanceBetween(center, e.latLng),
    );

    const distanceX = index === 1 || index === 3 ? distance : overlay.radiusX;
    const distanceY = index === 0 || index === 2 ? distance : overlay.radiusY;

    updateOverlay({
      center,
      distanceX,
      distanceY,
      angle: overlay.rotationAngle,
    });

    handlerInstance.setHandlerPosition({
      angle: overlay.rotationAngle,
      radiusX: distanceX,
      radiusY: distanceY,
      point: center,
    });

    ref.current.radiusX = distanceX;
    ref.current.radiusY = distanceY;
  };

  const updateOverlayValues = () => {
    setValues({
      overlay,
      radiusX: ref.current.radiusX,
      radiusY: ref.current.radiusY,
      paths: overlayInstance
        .getPath()
        .getArray()
        .map(item => ({ lat: item.lat(), lng: item.lng() })),
    });
  };

  useEffect(() => {
    let markerDragStart = null;
    let markerDrag = null;
    let markerDragEnd = null;

    const handlerMarker = handlerInstance.positions;

    for (let i = 0; i < handlerMarker.length; i += 1) {
      markerDragStart = maps.event.addListener(
        handlerMarker[i],
        'dragstart',
        markerSetInitialPosition,
      );
      markerDrag = maps.event.addListener(handlerMarker[i], 'drag', e =>
        markerDragNewPoints(e, i),
      );
      markerDragEnd = maps.event.addListener(
        handlerMarker[i],
        'dragend',
        updateOverlayValues,
      );
    }

    return () => {
      maps.event.removeListener(markerDragStart);
      maps.event.removeListener(markerDrag);
      maps.event.removeListener(markerDragEnd);

      overlayInstance.setMap(null);
      handlerInstance.positions.forEach(mark => {
        mark.setMap(null);
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [markerDragNewPoints]);

  return null;
};
CustomHandler.propTypes = {
  maps: PropTypes.object,
  setValues: PropTypes.func,
  overlay: PropTypes.object,
  overlayInstance: PropTypes.object,
  updateOverlay: PropTypes.func,
  handlerInstance: PropTypes.object,
};

export default CustomHandler;
